import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import { Icon } from '@node-space/ui-components'
import { PathNames } from 'constants/General'
import { isProduction } from 'utils/environment'
import { logout } from 'utils/utils'

export interface UserMenuItemsProps {
  isVerification?: boolean
}

export const useUserMenuItems = (config: UserMenuItemsProps = {}) => {
  const { isVerification = false } = config
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const menuListItems = useMemo(() => {
    const items = [
      {
        Icon: (
          <span className="text-foreground-prominent">
            <Icon name="Question" />
          </span>
        ),
        text: t('helpMenuSupportAndHelp'),
        hyperlink: process.env.SUPPORT_URL,
      },
      {
        Icon: (
          <span className="text-foreground-prominent">
            <Icon name="SignOut" />
          </span>
        ),
        text: t('logOut'),
        onClick: () => logout(),
      },
    ]

    // Add profile menu item if not on profile page and not in verification mode
    if (
      location.pathname !== `${PathNames.SETTINGS}${PathNames.MANAGE_USER_PROFILE}` &&
      !isVerification
    ) {
      items.unshift({
        Icon: (
          <span className="text-foreground-prominent">
            <Icon name="UserCircle" />
          </span>
        ),
        text: t('profile'),
        onClick: () => void navigate(`${PathNames.SETTINGS}${PathNames.MANAGE_USER_PROFILE}`),
      })
    }

    // Add developer docs for non-production environments
    if (!isProduction) {
      items.unshift({
        Icon: (
          <span className="text-foreground-prominent">
            <Icon name="ArrowSquareOut" />
          </span>
        ),
        text: t('developerDocs'),
        hyperlink: process.env.DEVELOPER_DOCS,
      })
    }

    return items
  }, [location.pathname, isVerification, t, navigate])

  return menuListItems
}
